import React from 'react';

import Spinner from 'components/Icons/Spinner';

import * as Styled from '../styled';

const LoadingIndicator: React.FC<unknown> = () => (
  <Styled.LoadingIndicatorWrapper>
    <Spinner height={22} width={22} duration='0.5s' />
  </Styled.LoadingIndicatorWrapper>
);

export default LoadingIndicator;
